import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class PointManage {
  // 新增点位类别
  static async insertPointType(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/basedata/point_type/insert', payload)
    )
    return Callback(err, res)
  }
  // 编辑点位类别
  static async editPointType(payload) {
    const [err, res] = await To(
      wizStandardInstance.patch('/api/basedata/point_type/update', payload)
    )
    return Callback(err, res)
  }
  // 查询点位类别列表
  static async getPointTypeList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/basedata/point_type/?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 删除点位类别
  static async deletePointType(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/Point_Type/point_type', {
        data: payload,
      })
    )
    return Callback(err, res)
  }
  // 新增点位
  static async insertPoint(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/Point/point', payload))
    return Callback(err, res)
  }
  // 编辑点位
  static async editPoint(payload) {
    const [err, res] = await To(wizStandardInstance.patch('/api/Point/point', payload))
    return Callback(err, res)
  }
  // 查询点位列表
  static async getPointList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Point/query_list/?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 删除点位
  static async deletePoint(payload) {
    const [err, res] = await To(wizStandardInstance.delete('/api/Point/point', { data: payload }))
    return Callback(err, res)
  }
  // 删除点位
  static async deleteDevicePoint(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/point/device_point', { data: payload })
    )
    return Callback(err, res)
  }
  // 导出点位
  static async exportExcel(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/Point/export_list', payload))
    return Callback(err, res)
  }
  // 导入点位
  static async uploadPoint(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/point/point/import', payload.formData)
    )
    return Callback(err, res)
  }
}
